import { audio } from "./audio";
import type { MusicTrack } from "./audio";
import { bossBedFor } from "./mixPolicy";

/** The enemies view's boss hooks (render/views/bossFx.ts BossEvents): listener lists. */
interface BossHooks {
  readonly onBossSpawn: ((boss: never) => void)[];
  readonly onBossPhase: ((phase: number, boss: never) => void)[];
  readonly onBossDeath: ((boss: never, at: never) => void)[];
  /** A boss that walked into the fortress (no fall). */
  readonly onBossGone?: ((boss: never) => void)[];
}

/**
 * The boss fight's music (A3, ENGAGEMENT B8): when a boss rises the battle bed cross-fades into the boss bed (the same
 * hook, lower and heavier, `art/audio/v6/compose.py` boss_bed), its phase change at half health lands a `bossPhase`
 * beat (a braam and drum hit that ducks the bed), and when the last boss falls the battle bed comes back. A level that
 * has ended (music null) or the hub is left alone (mixPolicy bossBedFor).
 */
export function attachBossMusic(hooks: BossHooks, skip: (boss: never) => boolean = () => false): void {
  let alive = 0;
  const follow = () => {
    const next = bossBedFor(audio.track, alive) as MusicTrack | null;
    if (next !== audio.track) audio.music(next);
  };
  // M36: a rare (`skip`) has its own bed and stingers (level/rareMoment.ts)
  hooks.onBossSpawn.push((b) => { if (skip(b)) return; alive++; follow(); });
  hooks.onBossPhase.push((_n, b) => { if (!skip(b)) audio.play("bossPhase"); });
  hooks.onBossDeath.push((b) => { if (skip(b)) return; alive = Math.max(0, alive - 1); follow(); });
  hooks.onBossGone?.push((b) => { if (skip(b)) return; alive = Math.max(0, alive - 1); follow(); });
}
